var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPracticeDisabledVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5V7H6.5V8.5H0V2H1.5V0.5H8ZM7.5 6.5V1H2V2H3V2.5H0.5V8H6V5.5H6.5V6.5H7.5ZM3.67578 5.17578L3.32422 4.82422L5.64453 2.5H4V2H6.5V4.5H6V2.85547L3.67578 5.17578Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPracticeDisabledVector);
export default __webpack_public_path__ + "static/media/practice-disabled-vector.fe15ec9eb2a42b17c52cfcf0849546a4.svg";
export { ForwardRef as ReactComponent };